import * as React from 'react'
import { useDomEvent } from 'hooks/use-dom-event'

const BREAKPOINTS = {
  SMALL: 640,
  TABLET: 720,
  MEDIUM: 768,
  LARGE: 1024,
  EXTRA_LARGE: 1280,
  '2_EXTRA_LARGE': 1440,
  '3_EXTRA_LARGE': 1920,
}

type Breakpoints = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'

export function useBreakpoint() {
  const [breakpoint, setBreakpoint] = React.useState<Breakpoints>()

  const handleResize = React.useCallback(() => {
    const width = window.innerWidth
    if (width < BREAKPOINTS.SMALL) {
      setBreakpoint('xs')
    } else if (width < BREAKPOINTS.MEDIUM) {
      setBreakpoint('sm')
    } else if (width < BREAKPOINTS.LARGE) {
      setBreakpoint('md')
    } else if (width < BREAKPOINTS.EXTRA_LARGE) {
      setBreakpoint('lg')
    } else if (width < BREAKPOINTS['2_EXTRA_LARGE']) {
      setBreakpoint('xl')
    } else if (width < BREAKPOINTS['3_EXTRA_LARGE']) {
      setBreakpoint('2xl')
    } else {
      setBreakpoint('3xl')
    }
  }, [])

  React.useEffect(() => {
    handleResize()
  }, [handleResize])
  useDomEvent(useDomEvent.window, 'resize', handleResize)

  const isMobile = ['xs', 'sm', 'md'].includes(breakpoint ?? '')

  return { breakpoint, isMobile }
}
